import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { IconButton, Slide } from "@mui/material";
import { InlineIcon } from "@iconify/react";
import "./ModalMouqabale.styles.scss";
import {
  TCreneau,
  TMemberCurrentExchange,
  TMiniProfil,
  TMouqabalaStep,
} from "@/features/profile/types";
import MouqStep1 from "./Stepper/MouqStep1";
import MouqStep2 from "./Stepper/MouqStep2";
import MouqStep3 from "./Stepper/MouqStep3";
import MouqStep4 from "./Stepper/MouqStep4";
import { apiCheckExistingMouqabala } from "@/features/profile/api/mouqabala.api";
import LoaderMini from "@/components/Loader-mini/LoaderMini";
import MouqExisting from "./Stepper/MouqExisting";
interface ModalMouqabalaProps {
  open: boolean;
  onClose:
    | ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void)
    | undefined;
  closeClick: () => void;
  currentExchange: TMemberCurrentExchange | null;
  receiver: TMiniProfil | null;
}
const ModalMouqabala = ({
  open,
  onClose,
  closeClick,
  currentExchange,
  receiver,
}: ModalMouqabalaProps) => {
  const [step, setStep] = useState<TMouqabalaStep>(1);
  const handleBackClick = () => {
    if (step === 1) {
      closeClick();
    } else if (step === 4) {
      closeClick();
    } else if (step > 1) {
      setStep((prev) => {
        let result = (prev - 1) as TMouqabalaStep;
        return result;
      });
    } else {
    }
  };

  const [selectedCreneau, setSelectedCreneau] = useState<Partial<TCreneau>>({
    creneau_date: "",
    creneau_start_time: "",
    creneau_end_time: "",
  });
  const [isMouqabalaExisting, setIsMouqabalaExisting] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkExistingMouqabala = () => {
    setLoading(true);
    apiCheckExistingMouqabala(currentExchange?.conversationId || "")
      .then((response: any) => {
        setLoading(false);
        console.log("🔥", response);
        if (response.data !== null) {
          setIsMouqabalaExisting(true);
        } else {
          setIsMouqabalaExisting(false);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        //Toastify(`${error?.response?.data?.message}`, "error", 5000);
        //setIsMouqabalaExisting(false); // <-- à supprimer quand api sera prêt
      });
  };

  useEffect(() => {
    checkExistingMouqabala();
  }, []);

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Slide in={open} direction="left" mountOnEnter unmountOnExit>
        <div className=" modal-mouqabala-container">
          {step < 4 && (
            <div className=" back">
              <IconButton
                size="large"
                color="primary"
                onClick={handleBackClick}
              >
                <InlineIcon icon="ion:arrow-back" />
              </IconButton>
            </div>
          )}

          <div className=" close">
            <IconButton size="large" color="inherit" onClick={closeClick}>
              <InlineIcon icon="material-symbols:close" />
            </IconButton>
          </div>
          <div className="content">
            <p className="title">
              {" "}
              Organiser une mouqabala avec <span>
                {receiver?.username}
              </span>{" "}
            </p>
            {loading ? (
              <LoaderMini />
            ) : (
              <>
                {isMouqabalaExisting ? (
                  <MouqExisting
                    close={closeClick}
                    receiver={receiver}
                    selectedCreneau={selectedCreneau}
                  />
                ) : (
                  <>
                    {step === 1 && (
                      <MouqStep1 setStep={setStep} close={closeClick} />
                    )}
                    {step === 2 && (
                      <MouqStep2
                        setStep={setStep}
                        close={closeClick}
                        receiver={receiver}
                        conversation_id={currentExchange?.conversationId || ""}
                      />
                    )}
                    {step === 3 && (
                      <MouqStep3
                        setStep={setStep}
                        close={closeClick}
                        setSelectedCreneau={setSelectedCreneau}
                        receiver={receiver}
                        conversation_id={currentExchange?.conversationId || ""}
                      />
                    )}
                    {step === 4 && (
                      <MouqStep4
                        setStep={setStep}
                        close={closeClick}
                        receiver={receiver}
                        selectedCreneau={selectedCreneau}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </Slide>
    </Modal>
  );
};

export default ModalMouqabala;
